import React, {Component} from 'react'
import { connect } from 'react-redux'
import { getRackList } from '../../actions/rackAction'
import { Alert, Col, Row, Card, CardBody } from 'reactstrap';
import Paginations from '../../components/Paginations/Paginations';
import { CardHeaderWithToolbars,Title } from '../../components/Card/CardHeaderWithToolbars';
import FilterContainer from '../../components/Container/FilterContainer/FilterContainer';
import Toolbars from './Filters/Toolbars';
import { DEFAULT_PER_PAGE } from '../../constants/settings';
import FilterPanel from './rack/FilterPanel';
import privateView from '../../components/hocs/privateView';
import List from './rack/List'
import ModalBulkUpload from './Modals/ModalBulkUpload'
import { Th } from '../../components/Tbl';
import qs from 'query-string';
import Analytics from "../../services/Analytics";

const defaultParams = {
  per_page : DEFAULT_PER_PAGE,
  sort_by: 'createdAt_desc'
}
const DEFAULT_ROUTE = '/racks';

class RackIndex extends Component {
	constructor(props) {
    super(props)
    const params = qs.parse(props.location.search);
		this.state={
      _exportOpen: false,
			_params:{
        ...defaultParams,
        keyword: params.keyword || ''
      },
      _list: [],
      _pagination: {},
      _filterOpen: params.keyword? true: false,
      _successAlertOpen: false,
      _selectedCategory: null
    }
    this._refreshList = this._refreshList.bind(this);
    this._handleApplyFilter = this._handleApplyFilter.bind(this);
    this._handleGoto = this._handleGoto.bind(this);
    this._handleToggleFilterPanel = this._handleToggleFilterPanel.bind(this);
    this._handleRefresh = this._handleRefresh.bind(this);
    this._handleResetFilter = this._handleResetFilter.bind(this);
    this._handleRemoveSuccessAlert = this._handleRemoveSuccessAlert.bind(this);
    this._handleToggleModalBulkUpload = this._handleToggleModalBulkUpload.bind(this);

  }

  componentDidMount(){
    const { email } = this.props.injectedProps;
    this._refreshList();
    Analytics.recordPageView('rack', email, {
      url: window.location.href,
      location: this.props.location,
      match: this.props.match
    });
  }

  componentWillReceiveProps(nextProps){
    const { isSubmit, isFetch } = nextProps.rack.list;
    if(isFetch !== this.props.rack.list.isFetch && !isFetch){
      if(nextProps.rack.list.error===null){
        const { data, ...pagination  } = nextProps.rack.list.data;
        this.setState({
          _list: data,
          _pagination: pagination
        })
      }
    }
  }

  shouldComponentUpdate(nextProps, nextState){
    if(nextProps.rack.isSubmit&&nextProps.rack.isSubmit!==this.props.rack.isSubmit){
      return false;
    }
    return true;
  }

  _handleApplyFilter(payloadFilter){
    this.setState({
      _params: {
        ...this.state._params,
        ...payloadFilter,
        page: 1
      }
    },()=>this._getList(this.state._params));
  }

  _getList(rawParams = {}){
    let params = {};
    Object.keys(rawParams)
    .filter(key => rawParams[key]!='')
    .forEach(key=> params[key] = rawParams[key]);
    this.props.getList({params});
  }

  _refreshList(){
    // Exclude page...
    const { page, ..._params } = this.state?._params;
    this.setState({
      _params:{ ..._params }
    },()=>this._getList(this.state._params));
  }

  _handleResetFilter(e){
    e.preventDefault();
    const exportState = this.state._exportOpen?{_exportOpen:!this.state._exportOpen}:{};
    this.setState({
      _params:{ ...defaultParams },
      ...exportState,
      _isResetFilter: true,
      _selectedCategory: null
    },()=>this._getList(this.state._params));
  }

  _handleRefresh(e){
    e.preventDefault();
    this._refreshList();
  }

  _handleToggleFilterPanel(e){
    e.preventDefault();
    this._toggleFilterPanel();
  }

  _toggleFilterPanel(){
    const exportState = this.state._exportOpen?{_exportOpen:!this.state._exportOpen}:{};
    this.setState({
      ...exportState,
      _filterOpen:!this.state._filterOpen
    })
  }


  _handleGoto(page){
    const _params=this.state._params;
    _params.page=page;
    this.setState({_params},()=>this._getList(this.state._params));
  }

  _handleRemoveSuccessAlert(){
    this.setState({
      _successAlertOpen: !this.state._successAlertOpen
    })
  }

  _onRenderPagination(){
		if(this.props.rack.list.status_code===200&&!this.props.rack.list.isFetch) {
      const { data } =this.props.rack.list;
      return (
        <Paginations
          isLoading={this.props.rack.list.isFetch}
          size="sm"
          lastPage={data.last_page}
          perPage={data.per_page}
          total={data.total}
          maxPage={8}
          path={data.path}
          currentPage={data.current_page}
          prevPageUrl={data.prev_page_url}
          nextPageUrl={data.next_page_url}
          handleGotoCallback={this._handleGoto}
          onCurrentPageChanged={currentPage => {
            window.scrollTo({
              top: this.tableRef.offsetTop+25,
              behavior: 'smooth'
            })
          }}
        />
      )
		}
		return null;
  }

  _handleToggleModalBulkUpload(){
    this.setState({
      _modalBulkUploadOpen: !this.state._modalBulkUploadOpen
    })
  }

  render() {
    return (
      <div className="animated fadeIn">
        <ModalBulkUpload
          isOpen={this.state._modalBulkUploadOpen}
          onToggle={this._handleToggleModalBulkUpload}
          dataBulk={this.props.bulkUploadStock}
          refreshAfterDone={true}
          onRefresh={this._refreshList}
          onClear={this.props.clearBulkForm}
        />
        <Row>
          <Col xs="12">
            <Card>
              <CardHeaderWithToolbars>
                <Title>
                  <i className="fa fa-align-justify"></i>
                  <span>Rack List</span>
                </Title>
                <Toolbars
                  isOpen={this.state._filterOpen}
                  isOpenExport={this.state._exportOpen}
                  onToggleModalBulkUpload={this._handleToggleModalBulkUpload}
                  onToggleFilter={this._handleToggleFilterPanel}
                  onRefreshList={this._handleRefresh}
                  onResetFilter={this._handleResetFilter}
                  onToggleExport={this._handleToggleExportPanel}
                />
              </CardHeaderWithToolbars>
              <FilterContainer>
                <FilterPanel
                  {...this.state._params}
                  isOpen={this.state._filterOpen}
                  onApplyFilter={this._handleApplyFilter}
                  isReset={this.state._isResetFilter}
                  onResetFilterCallback={()=>this.setState({_isResetFilter: false, _filterOpen: false})}
                />
              </FilterContainer>
              <CardBody>
                <Alert color="info" isOpen={this.state._successAlertOpen} toggle={this._handleRemoveSuccessAlert}>
                  <strong>Your list has been updated,</strong> maybe it can affect with your filter. Click (<i className="fa fa-refresh"></i>) button to refresh list.
                </Alert>
                <List
                  innerRefs={tableRef => this.tableRef = tableRef}
                  data={this.state._list}
                  isLoading={this.props.rack.list.isFetch}
                  from={this.state._pagination.from}
                  to={this.state._pagination.to}
                  perPage={this.state._pagination.per_page}
                  currentPage={this.state._pagination.current_page}
                  total={this.state._pagination.total}
                  defaultRoute={DEFAULT_ROUTE}
                  onRenderHeader={()=>(
                    <tr>
                      <Th>No.</Th>
                      <Th>Rack Name</Th>
                      <Th>Capacity</Th>
                      <Th>Updated</Th>
                      <Th>Action</Th>
                    </tr>
                  )}
                />
                {this._onRenderPagination()}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    );
  }
}
const mapStateToProps=({rack, bulkUploadStock, auth: { isFetch, isLogged, roles, id, email }})=> {
	return {
    rack,
    bulkUploadStock,
    guardData: { isFetch, isLogged, roles, id, email },
	}
}
const mapDispatchToProps=(dispatch)=> {
	return {
    getList:(filter)=>dispatch(getRackList(filter)),
    clearBulkForm:()=>dispatch({type:'CLEAR_BULK_STOCK'}),
	}
}
const enchance = connect(mapStateToProps,mapDispatchToProps);
export default enchance(privateView(RackIndex, ['supervisor','sale_supervisor']))